import { api } from '../../utils/api';
import axios from 'axios';

const login = async ({ email, password }) => {
  try {
    const res = await axios.post(
      `${api}/Signin`,
      {
        email,
        passward: password,
      },
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
        },
      }
    );
    return res;
  } catch (err) {
    return err;
  }
};

const register = async ({ email, password, address, name }) => {
  try {
    const res = await axios.post(
      `${api}/Signup`,
      {
        email,
        passward: password,
        address,
        name,
        mobile: '8888888888',
      },
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
        },
      }
    );
    return res;
  } catch (err) {
    return err;
  }
};

const forgotPassword = async ({ email }) => {
  try {
    const res = await axios.post(
      `${api}/ForgotPassward`,
      { email },
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
        },
      }
    );
    return res;
  } catch (err) {
    return err;
  }
};

const verifyCode = async ({ email, code }) => {
  try {
    const res = await axios.post(
      `${api}/VerifyCode`,
      { email, code },
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
        },
      }
    );
    return res;
  } catch (err) {
    return err;
  }
};

const resetPassword = async ({ email, password }) => {
  try {
    const res = await axios.post(
      `${api}/NewPassward`,
      {
        email,
        passward: password,
      },
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
        },
      }
    );
    return res;
  } catch (err) {
    return err;
  }
};

const authService = {
  login,
  register,
  forgotPassword,
  verifyCode,
  resetPassword,
};

export default authService;
